import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import MobileModal from 'srcReact/components/common2/MobileModal'
import Modal from 'srcReact/components/common2/Modal'
import InterestPicker from 'srcReact/components/common2/InterestPicker'
import Spinner from 'srcReact/components/common2/Spinner'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { profileActions } from 'srcReact/MyProfile/action'
import { commonActions } from 'srcReact/components'
import { organizationActions } from 'srcReact/OrganizationPage'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'

function UpdateInterestModal({ isOpen, interestType, closeModal, ctaPopup = '' }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    common: { isMobile, isNative, isTablet, selectedInterests },
    myProfile: { profileData, userInterests, userExpertise }
  } = useSelector((state) => state)

  const [saveTriggered, setSaveTriggered] = useState(false)

  useEffect(() => {
    const { loading, updated } = userInterests
    if (!loading && updated && saveTriggered) {
      setSaveTriggered(false)
      callHeaderInfoForNative() //to update myprofile ctas
      handleClose()
    }
  }, [userInterests, saveTriggered])

  useEffect(() => {
    const { loading, updated } = userExpertise
    if (!loading && updated && saveTriggered) {
      setSaveTriggered(false)
      callHeaderInfoForNative() //to update myprofile ctas
      handleClose()
    }
  }, [userExpertise, saveTriggered])

  const callHeaderInfoForNative = () => {
    if (isNative) {
      const organizationId = getCurrentOrgId()
      dispatch(organizationActions.getHeaderInfo(organizationId))
    }
  }

  const handleSave = () => {
    const ids = selectedInterests.map((i) => i.id).join(',')
    setSaveTriggered(true)
    if (interestType === 'interest') {
      dispatch(profileActions.putInterest(ids, ctaPopup))
    } else {
      dispatch(profileActions.updateExpertise(ids, ctaPopup))
    }
  }

  const handleClose = () => {
    dispatch(commonActions.updateSelectedInterests([]))
    closeModal()
  }
  const showInterestPickerContent = () => {
    return (
      <div className={styles.interestPickerModalContainer}>
        <InterestPicker
          componentType={interestType}
          origin='profile'
          isChallenge={true}
          existingInterests={interestType === 'expertise' ? userExpertise?.list : userInterests?.list}
          entityId={profileData?.user?.id}
          containerCss={styles.interestPickerContainer}
          showAddText={false}
          noMaxInterestsCount={true}
          minInterestsCount={interestType === 'interest' ? 3 : 0}
          primaryButton={{
            text: userInterests.loading || userExpertise.loading ? <Spinner /> : t('global.confirm'),
            size: 'large',
            clickHandler: handleSave
          }}
          secondaryButton={{ text: t('global.cancel'), size: 'large', clickHandler: handleClose }}
        />
      </div>
    )
  }

  return isMobile || isNative || isTablet ? (
    <MobileModal
      customContentStyle={{ maxHeight: '97vh' }}
      className={'interestModalMobile'}
      isOpen={isOpen}
      handleClose={handleClose}
      title={
        interestType === 'interest'
          ? t('interestPicker.modalTitleInt', { count: userInterests.list.length })
          : t('interestPicker.modalTitleExp', { count: userExpertise.list.length })
      }>
      {showInterestPickerContent()}
    </MobileModal>
  ) : (
    <Modal
      isOpen={isOpen}
      className={'interestModal'}
      customContentStyle={{ maxWidth: '650px' }}
      title={
        interestType === 'interest'
          ? t('interestPicker.modalTitleInt', { count: userInterests.list.length })
          : t('interestPicker.modalTitleExp', { count: userExpertise.list.length })
      }
      handleClose={handleClose}>
      {showInterestPickerContent()}
    </Modal>
  )
}

export default UpdateInterestModal
